angular.module('hcap-analytics')
.controller('CsmBundleCtrl', [
  '$scope',
  '$state',
  '$stateParams',
  'AlertService',
  'SurveyBundleService',
  '$anchorScroll',
  '$timeout',
  'PortalsService',
  function(
    $scope,
    $state,
    $stateParams,
    AlertService,
    SurveyBundleService,
    $anchorScroll,
    $timeout,
    PortalsService,
  ) {
    $scope.data = {
      portal: $stateParams.portal || 'CSM',
      portalName: '',
      loaded: false,
      error: false,
      state: null,
      rater: {
        name: '',
        email: '',
      },
    };

    PortalsService.get($scope.data.portal).then(portal => {
      $scope.data.portalName = portal.name;
    });

    $scope.template = null;
    $scope.designatedRaters = [];
    $scope.newDesignatedRater = $scope.data.rater;
    $scope.csmBundleFeedback = true;
    let initResultLinksReady = null;

    function loadState() {
      return SurveyBundleService.getBundle($stateParams.cohortId, $stateParams.token).then(state => {
        const wasReady = $scope.data.resultLinksReady;
        $scope.data.state = state;
        $scope.data.resultLinksReady = state.resultLinksReady;
        $scope.template = state.template;
        $scope.designatedRaters = state.designatedRaters || [];
        $scope.data.loaded = true;

        if (initResultLinksReady === null) {
          initResultLinksReady = state.resultLinksReady;
        } else if (!wasReady && state.resultLinksReady) {
          $timeout(() => { $anchorScroll('csm-bundle-results'); });
        }

        return state;
      });
    }

    $scope.addRater = function(form) {
      if (form.$invalid) {
        return;
      }

      $scope.data.busy = true;
      SurveyBundleService.addBundleRater($stateParams.cohortId, $stateParams.token, $scope.data.rater).then(result => {
        if (!result.created) {
          AlertService.warning('This feedback provider has already been invited.');
          return loadState();
        }

        return $scope.resetAddDesignatedRaterForm(form).then(() => loadState());
      }).finally(() => {
        $scope.data.busy = false;
      });
    };

    $scope.addDesignatedRater = $scope.addRater;

    $scope.resetAddDesignatedRaterForm = function(form) {
      $scope.data.rater = {
        name: '',
        email: '',
      };
      $scope.newDesignatedRater = $scope.data.rater;

      if (form) {
        form.$setPristine();
        form.$setUntouched();
      }

      return Promise.resolve();
    };

    $scope.sendDesignatedRaterNotification = function(designatedRater) {
      SurveyBundleService.resendBundleRater($stateParams.cohortId, $stateParams.token, designatedRater.email).then(result => {
        if (!result.count) {
          AlertService.warning('Unable to resend notification');
        }
      });
    };

    $scope.deleteDesignatedRater = function(designatedRater) {
      AlertService.confirm('Are you sure you want to delete this feedback provider?', 'Delete Feedback Provider', function(choice) {
        if (!choice) {
          return;
        }

        SurveyBundleService.deleteBundleRater($stateParams.cohortId, $stateParams.token, designatedRater.email).then(result => {
          if (!result.removed) {
            AlertService.warning('Unable to delete this feedback provider.');
            return;
          }

          loadState();
        });
      });
    };

    loadState().then(state => {
      if (state.next) {
        $state.go('participate.questions', {
          portal: $scope.data.portal,
          templateId: state.next.templateId,
          participantId: state.next.participantGuid,
          bundleToken: $stateParams.token,
          cohortId: $stateParams.cohortId,
          finishRoute: $state.current.name,
          finishRouteParams: {
            portal: $scope.data.portal,
            cohortId: $stateParams.cohortId,
            token: $stateParams.token,
          },
        });
      }
    }).catch(() => {
      $scope.data.loaded = true;
      $scope.data.error = true;
    });
  },
]);
